import styled from 'styled-components';
import { media } from '@anm/styles/helpers';

export const InfoBlockTitleTabletStyles = media.tablet`
  font-size: 20px;
  line-height: 1.4;
  text-align: left;
  padding-right: 50px;
`;

export const InfoBlockWrapperTabletStyles = media.tablet`
    margin-bottom: 30px;
`;

export const InfoBlockDescriptionTabletStyles = media.tablet`
   font-size: 16px;
   line-height: 1.75;
`;

export const InfoBlockDescriptionListItemTabletStyles = media.tablet`
   margin-bottom: 21px;
`;

export const InfoBlockPreview = styled.img`
  max-width: 100%;
  margin: 0 auto 22px;
  border-radius: 10px;
  display: ${({ src }: any) => (src ? 'block' : 'none')};
`;

export const InfoBlockTitle = styled.h1`
  color: #292a2b;
  font-size: 30px;
  font-weight: 400;
  line-height: 42px;
  text-align: center;
  margin: 0 0 25px;
  ${InfoBlockTitleTabletStyles};
`;

export const InfoBlockDescription = styled.div`
  color: #292a2b;
  font-size: 20px;
  font-weight: 400;
  line-height: 32px;
  ${InfoBlockDescriptionTabletStyles};
  ul {
    margin-top: 28px;
    margin-bottom: 30px;
    ${InfoBlockDescriptionListItemTabletStyles};
    li {
      margin-bottom: 36px;
      position: relative;
      padding-left: 31px;
      ${InfoBlockDescriptionListItemTabletStyles};
      &:last-child {
        margin-bottom: 0;
      }
      &:before {
        content: '';
        height: 16px;
        border-radius: 3px;
        background-color: #87ddf6;
        width: 16px;
        display: block;
        position: absolute;
        top: 10px;
        left: 0;
      }
      a {
        color: #2294df;
      }
    }
    &:last-child {
      margin-bottom: 0;
    }
  }
  br {
    &:first-child {
      display: none;
    }
  }
`;

const InfoBlockWrapper = styled.div`
  ${InfoBlockWrapperTabletStyles};
`;

export default InfoBlockWrapper;
